<div class="grid-container padding-bottom-4">
  <form [formGroup]="shipmentReviewForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
          <legend class="usa-legend usa-legend--large">HHG Shipment</legend>
        </div>
        @if (recent) {
          <div  class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <span>
              This report contains the recent 50 transactions. Please select 'All' from the status drop down and click 'Refresh' to see the list of all shipments.
            </span>
          </div>
        }
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3 pin-right">
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-7 desktop:grid-col-7">
              <label for="status">Status<abbr title="required"
              class="usa-hint usa-hint--required">*</abbr></label>
              @if (!carrierUser) {
                <select formControlName="status" (change)="statusChange($event)" id="status" name="status" placeholder="Status" class="usa-select">
                  <option value='All'>All</option>
                  @for (status of statuses; track status) {
                    <option [value]="status">{{status}}</option>
                  }
                </select>
              }
              @if (carrierUser) {
                <select formControlName="status" (change)="statusChange($event)" id="status" name="status" placeholder="Status" class="usa-select">
                  <option value=''>All</option>
                  @for (status of statusesTsp; track status) {
                    <option [ngValue]="status">{{status}}</option>
                  }
                </select>
              }
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
              <button type="button" class="usa-button pin-bottom" (click)="refreshTableandStatus()">Refresh</button>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
  <div class="grid-row grid-gap-1 margin-top-5">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <app-hhg-shipment-review-results [shipmentReviewList]="this.shipmentReviewList" [status]="this.status" [userPrefList]="this.userPrefList" [screenName]="this.screenName" [shipmentType]="this.shipmentType">
      </app-hhg-shipment-review-results>
    </div>
  </div>
</div>